export const getImagenWhatsApp = async (imagen) => {
    try {
        const idempresa = process.env.REACT_APP_DB_EMPRESA;

        const response = await fetch(
            `${process.env.REACT_APP_URL_APIHN24}/ver_imagen_gestor/${idempresa}?imagen=${imagen}`,
            {
                method: "GET",
                headers: {
                    Authorization: "Basic " + btoa("hinetService:99RHinet202"),
                    "Content-Type": "application/json",
                },
            }
        );

        if (!response.ok) {
            throw new Error("Error en la solicitud");
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};